// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__obQ9B","productName":"Table_productName__3PULk"};